import { useSiteSettings } from './useSiteSettings';
import { extractUserProfileUrls, UserProfileUrls } from 'lib/utils/user-profile-urls';

/**
 * Hook to get user profile URLs (login, signup, etc.) from site settings
 * Falls back to config URLs (generated at build time) if not configured in site settings
 * @returns Object containing user profile URLs
 */
export function useUserProfileUrls(): UserProfileUrls {
  const siteSettings = useSiteSettings();

  return extractUserProfileUrls(siteSettings);
}
